import type { CSSProperties } from 'react';

/**
 * Hoe een verwijzing eruitziet: blauw en vet, zonder streep. Eén constante, zodat ook
 * de plekken die nog via een callback klikken (de dashboardpanelen) er precies zo
 * uitzien als de componenten in `EntiteitLink`.
 *
 * `textDecoration: 'none'` staat er expliciet omdat `base.css` een `a:hover`
 * onderstreept; zonder deze regel gedraagt een link zich anders dan een span die
 * hetzelfde hoort te zijn.
 *
 * **Apart van `EntiteitLink.tsx` en niet erin**, want een bestand dat naast
 * componenten ook een object exporteert breekt fast refresh: bij het bewerken van
 * `AutoLink` herlaadt Vite dan de hele module in plaats van hem te verversen, en
 * verlies je de staat van de pagina. Zie `react-refresh/only-export-components` in
 * `eslint.config.js`.
 */
export const ENTITEIT_LINK: CSSProperties = {
  color: '#2A6085',
  fontWeight: 700,
  cursor: 'pointer',
  textDecoration: 'none',
};
